import React, { useContext, useState, useEffect } from 'react';

import Modal from 'components/modal';
import Button from 'components/button';
import Spacer from 'components/spacer';
import PanelStack from 'components/panel-stack';

import LocaleContext from 'contexts/locale-context';

import client from 'client';

import { GOOGLE_API_KEY, GOOGLE_APP_CLIENT_ID } from 'constants/index';

import './index.css';

let cb = null;

const withPicker = () => Component => (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [googleAccessToken, setGoogleAccessToken] = useState(null);
    const [dropboxAccessToken, setDropboxAccessToken] = useState(null);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [title, setTitle] = useState(null);
    const [selected, setSelected] = useState(null);
    const [type, setType] = useState(null);

    const { translations } = useContext(LocaleContext);
    const jsTranslations = translations.js;

    function retrieveAllGoogleFilesInFolder(folderId) {
        return new Promise((resolve, reject) => {
            const retrievePageOfChildren = function(request, result) {
                request.execute(function(resp) {
                  result = result.concat(resp.items);
                  const nextPageToken = resp.nextPageToken;
                  if (nextPageToken) {
                    request = window.gapi.client.drive.children.list({
                      folderId,
                      q: "mimeType = 'application/vnd.google-apps.folder'",
                      'pageToken': nextPageToken
                    });
                    retrievePageOfChildren(request, result);
                  } else {
                    Promise.all(result.map(folder => {
                      const request = window.gapi.client.drive.files.get({
                          fileId: folder.id,
                          fields: 'id, title, parents',
                      });
      
                      return new Promise(resolve2 => {
                          request.execute(resolve2);
                      })
                      // This is to remove any non-folder object (like an error object)
                    })).then(results => resolve(results.filter(res => !!res.id)))
                  }
                });
            }
            const initialRequest = window.gapi.client.drive.children.list({
                folderId,
                q: "mimeType = 'application/vnd.google-apps.folder'",
            });
            retrievePageOfChildren(initialRequest, []);
        })    
    }

    async function retrieveAllDropboxFilesInFolder(folderId) {
        let path = "";
        if (folderId && folderId != 'root') {
            path = folderId;
        }

        try {
            const resp = await client.post('https://api.dropboxapi.com/2/files/list_folder', JSON.stringify({ path }), {
                headers: {
                    'Authorization': `Bearer ${dropboxAccessToken}`,
                    "Content-Type": "application/json"
                }
            });

            const responses = resp.entries;

            let has_more = resp.has_more;

            if (has_more) {
                let cursor = resp.cursor;

                while(has_more) {
                    const resp2 = await client.post('https://api.dropboxapi.com/2/files/list_folder/continue', JSON.stringify({ cursor }), {
                        headers: {
                            'Authorization': `Bearer ${dropboxAccessToken}`,
                            "Content-Type": "application/json"
                        }
                    });

                    responses = responses.concat(resp2.entries);
                    has_more = resp2.has_more;
                    cursor = resp2.cursor;
                }
            }

            return responses.filter(response => response['.tag'] === 'folder');
        } catch (e) {}
    }

    useEffect(() => {
        if (googleAccessToken && !scriptLoaded && window.gapi && window.gapi.auth) {
            window.gapi.load('client', {'callback': () => {
                window.gapi.client.init({
                    apiKey: GOOGLE_API_KEY,
                    clientId: GOOGLE_APP_CLIENT_ID,
                    scope: 'https://www.googleapis.com/auth/drive.readonly'
                }).then(() => {
                    window.gapi.client.load('drive', 'v2', () => {
                        setScriptLoaded(true)
                    });
                })
            }});
        }
    }, [googleAccessToken]);

    const openPicker = ({ googleAccessToken, dropboxAccessToken, title, type }, done) => {
        setGoogleAccessToken(googleAccessToken);
        setDropboxAccessToken(dropboxAccessToken);
        setTitle(title)
        setType(type);

        if (googleAccessToken || dropboxAccessToken) setIsOpen(true);
        cb = done || null;
    }

    const closeConfirm = () => setIsOpen(false);

    const onButton = (resp) => {
        if (cb) {
            if (resp === 'yes') {
                cb(selected)
            } else {
                cb()
            }
        };
        setIsOpen(false);
    }

    const renderFooter = (active) => () => {
        return (
            <>
                <Button
                    btnType='none'
                    onClick={() => onButton('no')}
                >
                    {jsTranslations.cancel}
                </Button>
                <Button
                    onClick={() => onButton('yes')}
                    disabled={!active}
                >
                    {jsTranslations.confirm}
                </Button>
            </>
        );
    }

    let fetcher;
    let panelTitle;

    if (type === 'google') {
        fetcher = retrieveAllGoogleFilesInFolder;
        panelTitle = jsTranslations.my_drive;
    } if (type === 'dropbox') {
        fetcher = retrieveAllDropboxFilesInFolder;
        panelTitle = jsTranslations.files;
    }

    const showPanel = ((googleAccessToken && scriptLoaded) || dropboxAccessToken) && !!fetcher;

    return (
        <div className='withPicker'>
            <Component
                {...props}
                openPicker={openPicker}
                closeConfirm={closeConfirm}
            />
            <Modal
                isOpen={isOpen}
                onRequestClose={closeConfirm}
                renderFooter={renderFooter(!!selected)}
            >
                <div className='withPicker__modal'>
                    {title &&
                        <>
                            <h3 className='withPicker__modal__text withPicker__modal__title'>
                                {title}
                            </h3>
                        </>
                    }
                    {showPanel && <PanelStack
                        type={type}
                        fetcher={fetcher}
                        readyCb={setSelected}
                        title={panelTitle}
                    />}
                    <Spacer size='l'/>
                </div>
            </Modal>
        </div>
    )
};

export default withPicker;